import { render, staticRenderFns } from "./QuoteSection.vue?vue&type=template&id=35d68831&scoped=true&"
import script from "./QuoteSection.vue?vue&type=script&lang=js&"
export * from "./QuoteSection.vue?vue&type=script&lang=js&"
import style0 from "./QuoteSection.vue?vue&type=style&index=0&id=35d68831&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d68831",
  null
  
)

export default component.exports